const Home = () => {
  return <div>home</div>;
};
export default Home;
